import clsx from 'clsx';
import useTestTag from '../../../common/hooks/use-test-tag';
import OdinIcon, { OdinIconSize } from '../../odin-icon/odin-icon.component';
import type { DropDownResult } from './drop-down-types';

export interface DropDownChipProps {
  value: DropDownResult;
  readOnly?: boolean;
  onRemove: (value: DropDownResult) => void;
  disabled?: boolean;
}

export default function DropDownChip({ value, readOnly, disabled, onRemove }: DropDownChipProps) {
  const chipStyle = clsx(
    'odin-text-mono-1 odin-mr-1 odin-mb-1 odin-pl-2 odin-py-0.5 odin-rounded-lg odin-whitespace-nowrap odin-flex odin-items-center odin-justify-center',
    { 'odin-bg-primary-2 odin-pr-1': !readOnly && !disabled },
    { 'odin-bg-gray-3 odin-pr-2': readOnly || disabled }
  );

  const tagCreator = useTestTag(value.text || '');

  return (
    <div className={chipStyle} ref={tagCreator('option')}>
      {value.text}
      {!readOnly && !disabled && (
        <div className="odin-ml-1 odin-cursor-pointer" onClick={() => onRemove(value)} ref={tagCreator('selected')}>
          <OdinIcon icon="X" size={OdinIconSize.ExtraSmall} />
        </div>
      )}
    </div>
  );
}
